module.exports = __webpack_public_path__ + "img/bin.4379016b.svg";